module.exports = __webpack_public_path__ + "static/media/Nunito-Light.26261203.woff";